import { useState,useEffect } from "react";
import {collection, getDocs, getFirestore, onSnapshot, orderBy, query, where} from "firebase/firestore";

export default function Dashboard(){

    const [totalReq, setTotalReq] = useState("Loading");
    const [pendingReq, setPendingReq] = useState("Loading");
    const [rejectedReq, setRejectedReq] = useState("Loading");
    const [refundedReq, setRefundedReq] = useState("Loading");
    const [totalReqCompleted, setTotalReqCompleted] = useState("Loading");
    const [totalTransactionsRefunded, setTotalTransactionsRefunded] = useState("Loading");
    const [availableAmount, setAvailableAmount] = useState("Loading");
    const [profit, setProfit] = useState("Loading");
    const [withdrawn, setWithdrawn] = useState("Loading");
    const [users, setUsers] = useState("Loading");
    const [celebs, setCelebs] = useState("Loading");
    const db=getFirestore();

    useEffect(async() => {

        const unsubscribe= onSnapshot(collection(db,"requests"),(docs)=>{
          var tempCompleted=0;
          var docs=docs.docs;
          setTotalReq(docs.length);
          docs.forEach((doc)=>{
              var data=doc.data();
              if(data["status"]==="complete"){
                tempCompleted+=1;
              }

          })
          setTotalReqCompleted(tempCompleted);

        })

        const unsubscribe2= onSnapshot(collection(db,"requests"),(docs)=>{
            var tempPending=0;
            var docs=docs.docs;
            docs.forEach((doc)=>{
                var data=doc.data();
                if(data["status"]==="pending"){
                  tempPending+=1;
                }
  
            })
            setPendingReq(tempPending);
  
          })


          const unsubscribe3= onSnapshot(collection(db,"requests"),(docs)=>{
            var tempRefunded=0;
            var docs=docs.docs;
            docs.forEach((doc)=>{
                var data=doc.data();
                if(data["status"]==="refunded"){
                  tempRefunded+=1;
                }
            })
            setRefundedReq(tempRefunded);
          })



          const unsubscribe4= onSnapshot(collection(db,"requests"),(docs)=>{
            var tempRejected=0;
            var docs=docs.docs;
            docs.forEach((doc)=>{
                var data=doc.data();
                if(data["status"]==="rejected"){
                  tempRejected+=1;
                }
            })
            setRejectedReq(tempRejected);
          })






        var tempTotal=0;

        const q = query(collection(db, "transactions"), where("message", "==","DM Refund"),orderBy("createdAt"));
        var docs=await getDocs(q);
        docs.forEach((doc)=>{
            tempTotal+=doc.data()["amount"];
        })

        const q2 = query(collection(db, "transactions"), where("message", "==","Video Request Refund"),orderBy("createdAt"));
        var docs=await getDocs(q2);
        docs.forEach((doc)=>{
            tempTotal+=doc.data()["amount"];
        })

        setTotalTransactionsRefunded(tempTotal);





        var withdrawn=0;
        const withdraw = query(collection(db, "transactions"), where("message", "==","Withdraw"),orderBy("createdAt"));
        var docs=await getDocs(withdraw);
        docs.forEach((doc)=>{
            withdrawn+=doc.data()["amount"];
        })

        setWithdrawn(withdrawn);


        var minus=0;
        const minused = query(collection(db, "transactions"), where("from", "==","letsvibe"),orderBy("createdAt"));
        var docs=await getDocs(minused);
        docs.forEach((doc)=>{
            minus+=doc.data()["amount"];
        })

    

        var deposited=0;
        const deposit = query(collection(db, "transactions"), where("to", "==","letsvibe"),orderBy("createdAt"));
        var docs=await getDocs(deposit);
        docs.forEach((doc)=>{
            deposited+=doc.data()["amount"];
        })

        var profit=deposited*0.3;
        setProfit(profit);


        var cashInHand=deposited-withdrawn;
        setAvailableAmount(cashInHand);


        var totalUser=0;
        const users=collection(db,"users");
        var docs=await getDocs(users);
        docs.forEach((doc)=>{
            totalUser+=1;
        })
        setUsers(totalUser);

        var totalCeleb=0;
        const celeb=collection(db,"celebrities");
        var docs=await getDocs(celeb);
        docs.forEach((doc)=>{
            totalCeleb+=1;
        })
        setCelebs(totalCeleb);



    




    
        return function(){
            unsubscribe();
            unsubscribe2();
            unsubscribe3();
            unsubscribe4();
        };
    }, []);

    return(
        <div className="h-full w-full flex flex-wrap gap-3 justify-start items-center p-10">
            
            <div className="from-blue-600 to-purple-500 bg-gradient-to-br p-2  w-72 rounded-md font-bold flex flex-col justify-center items-start">
                <div className="text-xl font-normal">
                    {totalReq}
                </div>
                <div className="text-md font-normal">
                    Total Number of Requests
                </div>
            </div>


            <div className="from-red-500 to-red-400 bg-gradient-to-br p-2  w-72 rounded-md font-bold flex flex-col justify-center items-start">
                <div className="text-xl font-normal">
                    {totalReqCompleted}
                </div>
                <div className="text-md font-normal">
                    Total Requests Completed
                </div>
            </div>


            <div className="from-gray-600 to-gray-500 bg-gradient-to-br p-2  w-72 rounded-md font-bold flex flex-col justify-center items-start">
                <div className="text-xl font-normal">
                    {pendingReq}
                </div>
                <div className="text-md font-normal">
                    Total Requests Pending
                </div>
            </div>

            
            <div className="from-yellow-600 to-yellow-500 bg-gradient-to-br p-2  w-72 rounded-md font-bold flex flex-col justify-center items-start">
                <div className="text-xl font-normal">
                    {refundedReq}
                </div>
                <div className="text-md font-normal">
                    Total Requests Refunded
                </div>
            </div>

            <div className="from-orange-600 to-orange-500 bg-gradient-to-br p-2  w-72 rounded-md font-bold flex flex-col justify-center items-start">
                <div className="text-xl font-normal">
                    {rejectedReq}
                </div>
                <div className="text-md font-normal">
                    Total Requests Rejected
                </div>
            </div>


            <div className="from-red-600 to-red-500 bg-gradient-to-br p-2  w-72 rounded-md font-bold flex flex-col justify-center items-start">
                <div className="text-xl font-normal">
                    {totalTransactionsRefunded}₵
                </div>
                <div className="text-md font-normal">
                    Total Amount Refunded
                </div>
            </div>
           

            <div className="from-green-600 to-green-500 bg-gradient-to-br p-2  w-72 rounded-md font-bold flex flex-col justify-center items-start">
                <div className="text-xl font-normal">
                    {availableAmount}₵
                </div>
                <div className="text-md font-normal">
                    Total Cash In Hand
                </div>
            </div>



            <div className="from-teal-600 to-teal-500 bg-gradient-to-br p-2  w-72 rounded-md font-bold flex flex-col justify-center items-start">
                <div className="text-xl font-normal">
                    {profit}₵
                </div>
                <div className="text-md font-normal">
                    Total Profits
                </div>
            </div>


            <div className="from-blue-600 to-blue-500 bg-gradient-to-br p-2  w-72 rounded-md font-bold flex flex-col justify-center items-start">
                <div className="text-xl font-normal">
                    {withdrawn}₵
                </div>
                <div className="text-md font-normal">
                    Total Withdrawn
                </div>
            </div>

            
            <div className="from-purple-600 to-red-500 bg-gradient-to-br p-2  w-72 rounded-md font-bold flex flex-col justify-center items-start">
                <div className="text-xl font-normal">
                    {users}
                </div>
                <div className="text-md font-normal">
                    Total Users
                </div>
            </div>


            <div className="from-purple-600 to-purple-500 bg-gradient-to-br p-2  w-72 rounded-md font-bold flex flex-col justify-center items-start">
                <div className="text-xl font-normal">
                    {celebs}
                </div>
                <div className="text-md font-normal">
                    Total Celebrities
                </div>
            </div>
           
        
        </div>
    )
}